/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import Grid, { GridProps } from "@mui/material/Grid";
import EditIcon from "../../../SvgIcon/EditIcon";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import gridEditRowStyle from "./gridEditRowStyle";

type GridEditRowProps = {
  children: ReactNode;
  to: { pathname: string; state?: Record<string, any> };
  disabled?: boolean;
} & GridProps;

const GridEditRow = ({ children, to, disabled, ...rest }: GridEditRowProps) => {
  return (
    <Grid item {...rest}>
      {children}
      {!disabled && (
        <Button component={Link} to={to.pathname} state={to.state} sx={gridEditRowStyle.icon}>
          <EditIcon color={"primary"} />
        </Button>
      )}
    </Grid>
  );
};

export default GridEditRow;
